import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import ArrowLeft from "@redotech/redo-web/arbiter-icon/arrow-left.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import classNames from "classnames";
import * as headerCss from "./header.module.css";
export function Header({
  logo,
  merchantName,
  title,
  subtitle,
  onBack,
  leftAlign = false,
}: {
  logo: string | undefined;
  merchantName: string;
  title: string;
  subtitle: string;
  onBack?: () => void;
  leftAlign?: boolean;
}) {
  return (
    <Flex
      align={leftAlign ? "flex-start" : "center"}
      flexDirection="column"
      gap="3xl"
      justify="flex-start"
    >
      {onBack && (
        <Flex justify="space-between" p="none">
          <RedoButton
            centerItems={false}
            dataTestId="back-button"
            hierarchy="link"
            IconLeading={ArrowLeft}
            onClick={onBack}
            size="lg"
          />
        </Flex>
      )}
      {logo && (
        <Flex align="flex-start" justify="flex-start">
          <img
            alt={`Redo Returns Portal for ${merchantName}`}
            className={classNames(
              headerCss.logo,
              logo ? "" : headerCss.hiddenButAccessible,
            )}
            src={logo}
          />
        </Flex>
      )}
      <Flex
        align={leftAlign ? "flex-start" : "center"}
        dir="column"
        gap="xs"
        justify="flex-start"
      >
        <Text as="h1" fontSize="xl" fontWeight="semibold" textAlign="center">
          {title}
        </Text>
        <Text fontSize="sm" textAlign="center">
          {subtitle}
        </Text>
      </Flex>
    </Flex>
  );
}
